import { render, staticRenderFns } from "./TabbedInteractionSlide.vue?vue&type=template&id=536daaf0&scoped=true"
import script from "./TabbedInteractionSlide.vue?vue&type=script&lang=js"
export * from "./TabbedInteractionSlide.vue?vue&type=script&lang=js"
import style0 from "./TabbedInteractionSlide.vue?vue&type=style&index=0&id=536daaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536daaf0",
  null
  
)

export default component.exports